'use client'

import { useRef, type CSSProperties, type ReactNode } from 'react'
import { useStickyScrollReserve } from '@/hooks/useStickyScrollReserve'

/**
 * A sticky bar that reserves its own height in the document's
 * scroll-padding-top, for server-rendered pages that cannot call the hook.
 * See hooks/useStickyScrollReserve.ts.
 */
export function StickyScrollReserve({
  className,
  style,
  children,
}: {
  className?: string
  style?: CSSProperties
  children: ReactNode
}) {
  const ref = useRef<HTMLDivElement>(null)
  useStickyScrollReserve(ref)
  return (
    <div ref={ref} className={className} style={style}>
      {children}
    </div>
  )
}
